import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { TagsTable } from 'components/TagsTable';

export function Tags() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <TablePageLayout
      title="Теги"
      actionContent={
        <Button
          sx={{ ml: 5 }}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            tableRef.current?.openFormDialog();
          }}
        >
          Добавить тег
        </Button>
      }
    >
      <TagsTable
        id="tags-table"
        ref={tableRef}
        // editPageUrl="/tags"
        automaticallyOpenEditPage={false}
        searchFilter={{
          inputProps: {
            placeholder: 'Поиск по ID или названию',
          },
          filter: (search) => ({
            _or: search.flatMap((str) => [
              ...(parseInt(str, 10)
                ? [{ id: { _eq: parseInt(str, 10) } }]
                : []),
              { name: { _ilike: `%${str}%` } },
            ]),
          }),
        }}
      />
    </TablePageLayout>
  );
}
